"use client";

import React, { useEffect } from "react";
import { ArrowUpRightIcon } from "@heroicons/react/24/solid";

export default function AnimatedButton({
    text,
    link,
    blank,
    submit,
    showArrow,
    onClick,
    buttonClassName,
}: {
    text: string;
    link?: string;
    blank?: boolean;
    submit?: () => void;
    showArrow?: boolean;
    onClick?: () => void;
    buttonClassName?: string;
}) {
    useEffect(() => {
        const buttons =
            document.querySelectorAll<HTMLElement>(".primary-button");

        const cleanups: Array<() => void> = [];

        buttons.forEach((button) => {
            const item = button.querySelector<HTMLElement>(".round");

            if (!item) return;

            const handleMouseEnter = (event: MouseEvent) => {
                button.classList.add("animate");

                const buttonX = event.offsetX;
                const buttonY = event.offsetY;

                if (buttonY < 24) {
                    item.style.top = "0px";
                } else if (buttonY > 30) {
                    item.style.top = "48px";
                }

                item.style.left = `${buttonX}px`;
                item.style.width = "1px";
                item.style.height = "1px";
            };

            const handleMouseLeave = (event: MouseEvent) => {
                button.classList.remove("animate");

                const buttonX = event.offsetX;
                const buttonY = event.offsetY;

                if (buttonY < 24) {
                    item.style.top = "0px";
                } else if (buttonY > 30) {
                    item.style.top = "48px";
                }

                item.style.left = `${buttonX}px`;
            };

            button.addEventListener("mouseenter", handleMouseEnter);
            button.addEventListener("mouseleave", handleMouseLeave);

            cleanups.push(() => {
                button.removeEventListener("mouseenter", handleMouseEnter);
                button.removeEventListener("mouseleave", handleMouseLeave);
            });
        });

        return () => {
            cleanups.forEach((cleanup) => cleanup());
        };
    }, []);

    return (
        <div className="button-container relative overflow-hidden rounded-full group">
            {submit ? (
                <button
                    className={`primary-button py-[0.8rem] px-[2.4rem] rounded-full uppercase justify-center flex items-center group-hover:border-purple ${buttonClassName || ""}`}
                    onClick={submit}
                >
                    <span className="relative text-center group-hover:text-white duration-300 z-20 font-semibold inline-flex items-center gap-2">
                        {text}
                        {showArrow && <ArrowUpRightIcon className="w-4 h-4" />}
                    </span>
                    <span className="absolute bg-[#00FE8A] w-full h-full top-0 bottom-0 left-0 right-0 z-0"></span>
                    <span className="round z-10"></span>
                </button>
            ) : (
                // <Link
                //     href={link ? link : '#'}
                //     className="primary-button py-[0.8rem] px-[2.4rem] rounded-full uppercase justify-center flex items-center group-hover:border-purple"
                //     target={blank ? "_blank" : "_self"}
                // >
                <a
                    href={link ? link : "#"}
                    className={`primary-button py-[0.8rem] px-[2.4rem] rounded-full uppercase justify-center flex items-center group-hover:border-purple ${buttonClassName || ""}`}
                    target={blank ? "_blank" : "_self"}
                    onClick={(e) => {
                        if (onClick) {
                            e.preventDefault();
                            onClick();
                        }
                    }}
                >
                    <span className="relative text-center group-hover:text-white duration-300 z-20 font-semibold inline-flex items-center gap-2">
                        {text}
                        {showArrow && <ArrowUpRightIcon className="w-4 h-4" />}
                    </span>
                    <span className="absolute bg-[#00FE8A] w-full h-full top-0 bottom-0 left-0 right-0 z-0"></span>
                    <span className="round z-10"></span>
                    {/* </Link> */}
                </a>
            )}
        </div>
    );
}
